import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library-shop';
import { StyledCheckboxItemDiv } from '../../organisms/SearchResults/index.styles';

export const StyledHotelTypeFilterDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};

  input[type='checkbox'] + label {
    background: transparent;
  }
  .filter-heading-container {
    margin-bottom: ${toRem(16)};
  }

  ${StyledCheckboxItemDiv} {
    input[type='checkbox'] + label {
      &.checkbox-label {
        padding-right: 0;
        width: fit-content;
      }
    }
  }
  `}
`;
